import { motion } from "framer-motion";
import { BatteryLow, HeartPulse, Users, Crown, Waves, Sparkles } from "lucide-react";
import { useHome } from "@/context/HomeContent";
import { fadeUp, staggerParent, viewportOnce } from "@/lib/animations";

const ICONS = [BatteryLow, HeartPulse, Users, Crown, Waves, Sparkles];

const WhyOrganizations = () => {
  const { home } = useHome();
  const d = home.why;
  return (
    <section id="why" data-testid="why-section" className="bg-brand-cream py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={viewportOnce} className="max-w-3xl">
          <motion.p variants={fadeUp} className="mb-5 font-heading text-xs font-bold uppercase tracking-[0.22em] text-brand-magenta">{d.eyebrow}</motion.p>
          <motion.h2 variants={fadeUp} className="font-heading text-4xl font-semibold leading-[1.05] tracking-tight text-brand-ink sm:text-5xl lg:text-[3.6rem]">
            {d.headingLead}{" "}
            <span className="brand-gradient-text">{d.headingAccent}</span>
          </motion.h2>
        </motion.div>

        <motion.div variants={staggerParent} initial="hidden" whileInView="show" viewport={viewportOnce} className="mt-14 grid grid-cols-1 overflow-hidden rounded-2xl border border-brand-line sm:grid-cols-2 lg:grid-cols-3">
          {(d.cards || []).map((c, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div key={c.n || i} variants={fadeUp} data-testid={`why-card-${c.n}`} className="group relative border-b border-r border-brand-line bg-brand-cream p-8 transition-colors duration-500 hover:bg-white lg:p-10">
                <div className="flex items-start justify-between">
                  <span className="font-heading text-sm font-bold tracking-widest text-brand-ink/30">{c.n}</span>
                  <Icon className="h-6 w-6 text-brand-magenta transition-transform duration-500 group-hover:-translate-y-1 group-hover:scale-110" />
                </div>
                <h3 className="mt-10 font-heading text-2xl font-semibold text-brand-ink">{c.title}</h3>
                <p className="mt-3 font-body text-[15px] leading-relaxed text-brand-ink/65">{c.desc}</p>
                <span className="absolute bottom-0 left-0 h-0.5 w-0 brand-gradient transition-[width] duration-500 group-hover:w-full" />
              </motion.div>
            );
          })}
        </motion.div>

        <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} className="mx-auto mt-16 max-w-3xl text-center font-heading text-2xl font-semibold leading-snug text-brand-ink sm:text-3xl lg:text-4xl">
          &ldquo;{d.tagline}&rdquo;
        </motion.p>
      </div>
    </section>
  );
};

export default WhyOrganizations;
